import * as React from "react";
import {INPUT_TYPE, StyleType} from "utils/variables";
import {TextField, SelectField} from "web-com";
import {FIELD_NAMES} from "profile/enums";
import {companyTypeOptions} from "IncompleteInfoV2/WorkDetails/utils";
import {EmployerName, IEmployerDetails} from "IncompleteInfoV2/WorkDetails/employerName";
import {maxPincodeLength} from "IncompleteInfoV2/utils";
import {IWorkDetailsFields} from "IncompleteInfoV2/WorkDetails/index";

interface IProps {
    workFields: IWorkDetailsFields;
    onChange: (fieldName: string, value: string) => void;
    errors?: {[key: string]: string};
}

const AddressFields = (props: IProps) => {
    const {
        workExperienceMonths,
        employerType,
        house,
        locality,
        pincode,
        employeeId,
        designation,
        duration,
        street,
        landmark,
    } = props.workFields;
    const handleChange = (fieldName: string, value: string) => {
        props.onChange(fieldName, value);
    };
    const handleSelectedCompany = (employerDetails: IEmployerDetails) => {
        props.onChange(FIELD_NAMES.CURRENT_EMPLOYER, employerDetails.currentEmployer);
        props.onChange(FIELD_NAMES.WORK_CIN, employerDetails.workCin);
    };
    return (
        <>
            <TextField
                type={INPUT_TYPE.TEXT}
                label="Total work experience (In Months)"
                placeholder="Please enter work experience"
                value={workExperienceMonths}
                fieldName={FIELD_NAMES.WORK_EXPERIENCE_MONTHS}
                onChange={handleChange}
                errorMsg={props.errors[FIELD_NAMES.WORK_EXPERIENCE_MONTHS] || null}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
            />
            <EmployerName
                workDetails={props.workFields}
                onChange={handleSelectedCompany}
                isAndroid={false}
                errors={props.errors[FIELD_NAMES.CURRENT_EMPLOYER] || props.errors[FIELD_NAMES.WORK_CIN] || null}
            />
            <TextField
                type={INPUT_TYPE.TEXT}
                label="Employee ID"
                placeholder="Please enter Employee Id"
                value={employeeId}
                fieldName={FIELD_NAMES.EMPLOYEE_ID}
                onChange={handleChange}
                errorMsg={props.errors[FIELD_NAMES.EMPLOYEE_ID] || null}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
            />
            <TextField
                type={INPUT_TYPE.TEXT}
                label="Designation"
                placeholder="Please enter your designation"
                value={designation}
                fieldName={FIELD_NAMES.DESIGNATION}
                onChange={handleChange}
                errorMsg={props.errors[FIELD_NAMES.DESIGNATION] || null}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
            />
            <TextField
                type={INPUT_TYPE.DATE}
                label="Working Since"
                placeholder="Please select working since"
                value={duration}
                fieldName={FIELD_NAMES.DURATION}
                onChange={handleChange}
                errorMsg={props.errors[FIELD_NAMES.DURATION] || null}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
            />
            <SelectField
                options={companyTypeOptions}
                onChangeHandler={handleChange}
                fieldName={FIELD_NAMES.EMPLOYER_TYPE}
                name={"Company type"}
                value={employerType}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
                errorMsg={props.errors[FIELD_NAMES.EMPLOYER_TYPE] || null}
            />
            <TextField
                type={INPUT_TYPE.TEXT}
                label="Building no"
                placeholder="Please enter building no"
                value={house}
                fieldName={FIELD_NAMES.HOUSE}
                onChange={handleChange}
                errorMsg={props.errors[FIELD_NAMES.HOUSE] || null}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
            />
            <TextField
                type={INPUT_TYPE.TEXT}
                label="Work address locality"
                placeholder="Please enter locality"
                value={locality}
                fieldName={FIELD_NAMES.LOCALITY}
                onChange={handleChange}
                errorMsg={props.errors[FIELD_NAMES.LOCALITY] || null}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
            />
            <TextField
                type={INPUT_TYPE.TEXT}
                label="Street name"
                placeholder="Please enter street name"
                value={street}
                fieldName={FIELD_NAMES.STREET}
                onChange={handleChange}
                errorMsg={props.errors[FIELD_NAMES.STREET] || null}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
            />
            <TextField
                type={INPUT_TYPE.TEXT}
                label="Landmark"
                placeholder="Please enter landmark"
                value={landmark}
                fieldName={FIELD_NAMES.LANDMARK}
                onChange={handleChange}
                errorMsg={props.errors[FIELD_NAMES.LANDMARK] || null}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
            />
            <TextField
                type={INPUT_TYPE.NUMBER}
                label="Work address pincode"
                placeholder="Please enter work pincode"
                value={pincode}
                fieldName={FIELD_NAMES.PINCODE}
                onChange={handleChange}
                errorMsg={props.errors[FIELD_NAMES.PINCODE] || null}
                styleType={StyleType.BORDER_BOTTOM_INPUT}
                max={maxPincodeLength}
            />
        </>
    );
};

export default AddressFields;
